export default [
  {
    path: "/kependudukan",
    component: () => import("@/pages/kependudukan/kependudukan-list.vue"),
    meta: {
      requiredLevel: ["admin", "kependudukan"],
    },
  },
  {
    path: "/kependudukan/import",
    component: () => import("@/pages/kependudukan/kependudukan-import.vue"),
    meta: {
      requiredLevel: ["admin", "kependudukan"],
    },
  },
  {
    path: "/kependudukan/detail/:id",
    component: () => import("@/pages/kependudukan/kependudukan-detail.vue"),
    meta: {
      requiredLevel: ["admin", "kependudukan"],
    },
  },
];
